var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2345 0.479738L33.4141 0.469574L33.6343 0.483126L33.7868 0.510229L33.9951 0.569519L34.1764 0.647442L34.3458 0.743999L34.4982 0.857496L34.6371 0.984545L34.7252 1.08449L34.8641 1.28099L34.9522 1.44361C35.0313 1.61301 35.0821 1.79145 35.1047 1.97891L35.1131 2.15847C35.1131 2.28609 35.0996 2.41031 35.0725 2.53115L35.0132 2.73951L23.9481 33.3616C23.7383 33.8183 23.402 34.2051 22.9789 34.4763C22.5558 34.7474 22.0638 34.8915 21.5613 34.8913C21.1088 34.8922 20.6637 34.7762 20.2693 34.5545C19.8748 34.3328 19.5444 34.0129 19.31 33.6259L19.1999 33.4108L13.5216 22.0577L2.22277 16.4066C1.80469 16.2154 1.44415 15.9177 1.17719 15.5435C0.910239 15.1692 0.74623 14.7314 0.70157 14.2738L0.691406 14.0214C0.691406 13.0728 1.2013 12.2055 2.11605 11.7007L2.3532 11.5821L32.8737 0.561049L33.0533 0.510229L33.2345 0.479738Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/RedArrow.2898257a8cab265af3c38ea871eea6ef.svg";
export { ForwardRef as ReactComponent };